// 숫자를 한글 금액으로 변환 (예: 385000 → 삼십팔만오천)

const UNITS = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
const PLACE = ['', '십', '백', '천'];
const BIG_PLACE = ['', '만', '억', '조'];

function convertBlock(part: number): string {
  if (part === 0) return '';
  let str = '';
  for (let j = 3; j >= 0; j--) {
    const digit = Math.floor(part / Math.pow(10, j)) % 10;
    if (digit === 0) continue;
    // 일십, 일백, 일천은 그냥 십, 백, 천으로 표기
    if (digit === 1 && j > 0) {
      str += PLACE[j];
    } else {
      str += UNITS[digit] + PLACE[j];
    }
  }
  return str;
}

export function numberToKorean(num: number): string {
  if (num === 0) return '영';
  if (!isFinite(num) || isNaN(num)) return '영';

  const n = Math.abs(Math.floor(num));
  if (n === 0) return '영';

  const blocks: number[] = [];
  let temp = n;
  while (temp > 0) {
    blocks.push(temp % 10000);
    temp = Math.floor(temp / 10000);
  }

  let result = '';
  for (let i = blocks.length - 1; i >= 0; i--) {
    if (blocks[i] === 0) continue;
    result += convertBlock(blocks[i]) + BIG_PLACE[i];
  }

  return result;
}

// 금액 쉼표 포맷
export function formatNumber(num: number): string {
  if (!num && num !== 0) return '0';
  return Math.round(num).toLocaleString('ko-KR');
}

// 날짜를 YYYY년 MM월 DD일 형식으로
export function formatDateKorean(dateStr: string): string {
  if (!dateStr) return '';
  // YYYY-MM-DD 파싱 (로컬 타임존 유지)
  const parts = dateStr.split('-');
  if (parts.length === 3) {
    return `${parts[0]}년 ${parts[1]}월 ${parts[2]}일`;
  }
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return `${d.getFullYear()}년 ${String(d.getMonth() + 1).padStart(2, '0')}월 ${String(d.getDate()).padStart(2, '0')}일`;
}

// 영수증용 날짜 형식 YY. M. D
export function formatDateReceipt(dateStr: string): string {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length === 3) {
    const yy = parts[0].slice(2);
    return `${yy}. ${Number(parts[1])}. ${Number(parts[2])}`;
  }
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const yy = String(d.getFullYear()).slice(2);
  return `${yy}. ${d.getMonth() + 1}. ${d.getDate()}`;
}

// 영수증 품목 월일 형식 M/D
export function formatMonthDay(dateStr: string): string {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length === 3) {
    return `${Number(parts[1])}/${Number(parts[2])}`;
  }
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return `${d.getMonth() + 1}/${d.getDate()}`;
}

// YYYYMMDD 형식
export function formatDateCompact(dateStr: string): string {
  if (!dateStr) return '';
  return dateStr.replace(/-/g, '');
}

// 오늘 날짜 YYYY-MM-DD
export function getTodayString(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

// 파일명에서 특수문자 제거
export function sanitizeFilename(name: string): string {
  return name
    .replace(/[\\/:*?"<>|]/g, '')
    .replace(/\s+/g, '_')
    .trim();
}

// 합계금액 한글 표기
export function formatAmountKorean(amount: number): string {
  return `일금 ${numberToKorean(amount)} 원정`;
}
